import { render, staticRenderFns } from "./table-empty-message.vue?vue&type=template&id=5b2fee7e"
import script from "./table-empty-message.vue?vue&type=script&lang=js"
export * from "./table-empty-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports